import React, { Fragment } from 'react';
import { UserCheckIcon, SmartphoneIcon, FileCheckIcon, FileTextIcon, DollarSignIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
interface Stage {
  name: string;
  rate: string;
  volume: string;
  icon: React.ElementType;
  color: string;
}
interface PullThroughMetricsProps {
  selectedLO: string;
}
const stageDataByLO: Record<string, {
  rates: string[];
  volumes: string[];
}> = {
  all: {
    rates: ['95%', '88%', '75%', '62%', '45%', '40%'],
    volumes: ['1,250', '1,100', '1,100', '1,100', '750', '750']
  },
  'Sarah Chen': {
    rates: ['92%', '85%', '70%', '58%', '42%', '36%'],
    volumes: ['180', '166', '150', '126', '91', '78']
  },
  'Michael Davis': {
    rates: ['90%', '82%', '68%', '55%', '38%', '32%'],
    volumes: ['210', '189', '172', '143', '99', '83']
  },
  'Chrao Dunon': {
    rates: ['97%', '92%', '80%', '68%', '52%', '48%'],
    volumes: ['165', '160', '152', '132', '112', '103']
  },
  'Alex Kim': {
    rates: ['94%', '86%', '72%', '60%', '43%', '38%'],
    volumes: ['195', '183', '168', '140', '117', '100']
  },
  'Priya Patel': {
    rates: ['96%', '90%', '78%', '65%', '48%', '44%'],
    volumes: ['220', '211', '198', '172', '143', '132']
  },
  'Jann Fmt': {
    rates: ['98%', '94%', '84%', '72%', '56%', '52%'],
    volumes: ['140', '137', '132', '118', '101', '93']
  },
  'Roda Kim': {
    rates: ['97%', '93%', '82%', '70%', '54%', '50%'],
    volumes: ['140', '136', '130', '115', '98', '91']
  }
};
const stageNames = ['LEAD CLAIM', 'APP', 'APP COMPLETED', 'SUBMISSION', 'CTC', 'FUNDED'];
const stageIcons = [UserCheckIcon, SmartphoneIcon, FileCheckIcon, FileTextIcon, DollarSignIcon, CheckCircleIcon];
export function PullThroughMetrics({
  selectedLO
}: PullThroughMetricsProps) {
  const loData = stageDataByLO[selectedLO] || stageDataByLO['all'];
  const stages: Stage[] = stageNames.map((name, i) => ({
    name,
    rate: loData.rates[i],
    volume: loData.volumes[i],
    icon: stageIcons[i],
    color: name === 'FUNDED' ? 'border-green-400 bg-green-100' : 'border-blue-300 bg-blue-50'
  }));
  return <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-99">
      <div className="flex items-center justify-between mb-8" data-id="element-100">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-101">
          PULL THROUGH METRICS
        </h2>
        {selectedLO !== 'all' && <span className="text-sm text-gray-500" data-id="element-102">
            Showing metrics for{' '}
            <span className="font-semibold text-gray-700" data-id="element-103">{selectedLO}</span>
          </span>}
      </div>

      <div className="flex items-center justify-between gap-4" data-id="element-104">
        {stages.map((stage, index) => <Fragment key={stage.name} data-id="element-105">
            <div className="flex flex-col items-center flex-1" data-id="element-106">
              <div className={`w-full border-2 ${stage.color} rounded-lg p-6 flex flex-col items-center justify-center min-h-[140px]`} data-id="element-107">
                <stage.icon className={`w-8 h-8 mb-3 ${stage.name === 'FUNDED' ? 'text-green-600' : 'text-blue-600'}`} data-id="element-108" />
                <div className="text-center" data-id="element-109">
                  <p className="text-xs font-bold text-gray-900 mb-1" data-id="element-110">
                    {stage.name}
                  </p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-111">
                    ({stage.rate})
                  </p>
                </div>
              </div>

              <div className="w-full mt-4 text-center space-y-1" data-id="element-112">
                <p className="text-sm font-semibold text-gray-900" data-id="element-113">
                  {stage.rate}
                </p>
                <p className="text-xs text-gray-600" data-id="element-114">Volume:</p>
                <p className="text-sm font-bold text-gray-900" data-id="element-115">
                  {stage.volume}
                </p>
              </div>
            </div>

            {index < stages.length - 1 && <div className="flex items-center justify-center -mx-2 mt-[-80px]" data-id="element-116">
                <ArrowRightIcon className="w-8 h-8 text-blue-500" strokeWidth={3} data-id="element-117" />
              </div>}
          </Fragment>)}
      </div>
    </div>;
}